import {WellQcTableData} from "src/modules/types";

export class GetWellQcTableData {
  static readonly type = '[BuildModel] Get Well Qc table data';

  constructor(public payload: WellQcTableData[]) {
  }
}
